<div class="section-title">{{ sectionTitle }}</div>

<ul>
  <li class="goal-wrapper" *ngFor="let goal of goals; let i = index" [class.unselectable]="goal.id === unselectableId" [class.border-top]="i === 0" data-test-id="objective-selector-objective">
    <i class="fs-16px sp-mt-2" [uiTooltipTitle]="'objective' | localize" ui-icon ui-tooltip uiTheme="fill" uiType="goal"></i>
    <div class="goal-title sp-mb-0 private-wrapper" ui-typography uiEllipsis data-test-id="objective-selector-objective-title">
      <span class="gh-badge open" *ngIf="goal.private">{{ "private" | localize }}</span
      >{{ goal.name }}
    </div>
    <div class="goal-session sp-mb-0" ui-typography uiEllipsis>{{ sessionsMap[goal.sessionId].title }}</div>
    <div class="sp-mx-12">
      <ui-assignee-avatar-group *ngIf="goal.ownerIds" [uiMax]="5" [uiAlignRight]="true" uiSize="xs">
        <ui-assignee-avatar *ngFor="let assigneeId of goal.ownerIds" [fromAssigneeId]="assigneeId" />
      </ui-assignee-avatar-group>
    </div>
    <button class="sp-ml-auto sp-mr-32 select-btn" *ngIf="goal.id !== unselectableId" (click)="onGoalSelected(goal)" ui-button uiType="primary" uiShape="round" data-test-id="select-button">
      {{ "select" | localize }}
    </button>
  </li>
</ul>
